import { isEmpty, get } from 'lodash'

const helpers = {
    buildMarketPlaceCriteriaList: secondParty => {
        let _data = {}
        for (const provider of secondParty.activeProviders) {
            _data = {
                ..._data,
                [provider]: !isEmpty(get(secondParty, `activeList[${provider}].list`, []))
            }
        }
        return _data
    },
    buildCategories: (rootState, rootGetters) => {
        const accountCountry = get(rootState, 'account.country.label', 'geography')
        const getSettingValue = settingName => {
            return rootGetters['data/settings/getSocioDemoValue']({ settingName })
        }

        return [
            {
                myData: {
                    customTaxonomies: !isEmpty(rootState.data.customTaxonomies.list),
                    media: !rootGetters['data/media/getIsConversionEmpty']({}) || !rootGetters['data/media/getIsCampaignEmpty']({})
                }
            },
            {
                sharing: {
                    audiences: !isEmpty(rootGetters['data/audience/getSharedAudiences']()),
                    taxonomies: !isEmpty(rootGetters['data/taxonomies/getSharedTaxonomies']())
                }
            },
            {
                marketPlace: helpers.buildMarketPlaceCriteriaList(rootState.data.secondParty)
            },
            {
                thirdParty: {
                    demographic: getSettingValue('demographic') && !isEmpty(rootState.data.demographic.list),
                    behavioral: getSettingValue('behavioral') && !isEmpty(rootState.data.behavioral.list)
                }
            },
            {
                geography: {
                    [accountCountry]: getSettingValue('geography') && !isEmpty(rootState.data.geography.list),
                    georadar:
                        getSettingValue('geography') &&
                        (!isEmpty(rootState.data.georadar.savedPoints) || !isEmpty(rootGetters['data/georadar/getActiveItems']({})))
                }
            },
            {
                audiences: {
                    audience: !isEmpty(rootGetters['data/audience/getActiveItems']({}))
                }
            },
            {
                technology: getSettingValue('technology')
                    ? {
                        browser: !isEmpty(rootState.data.browser.list),
                        device: !isEmpty(rootState.data.device.list),
                        os: !isEmpty(rootState.data.os.list),
                        isp: !isEmpty(rootState.data.isp.list)
                    }
                    : { browser: false, device: false, os: false, isp: false }
            }
        ]
    },
    buildCriteriaList: (categories, rootState) => {
        const accountCountry = get(rootState, 'account.country.label', 'geography')
        const _criteriaList = []
        for (const category of categories) {
            let criterion = {}
            for (const _categoryKey in category) {
                let categories = {}
                for (const clKey in category[_categoryKey]) {
                    if (category[_categoryKey][clKey]) {
                        if (_categoryKey === 'sharing') {
                            categories = Object.assign(
                                categories,
                                clKey === 'audiences' && {
                                    audiences: {
                                        type: 'sharedAudiences'
                                    }
                                },
                                clKey === 'taxonomies' && {
                                    taxonomies: {
                                        type: 'taxonomies',
                                        subType: 'sharing'
                                    }
                                }
                            )
                        } else if (_categoryKey !== 'marketPlace') {
                            categories = {
                                ...categories,
                                [clKey]: clKey === accountCountry ? get(rootState, 'data.geography', {}) : get(rootState, `data[${clKey}]`, {})
                            }
                        } else {
                            categories = {
                                ...categories,
                                [clKey]: get(rootState, `data.secondParty.activeList[${clKey}]`, {})
                            }
                        }
                    }
                }
                criterion = isEmpty(categories) ? { ...criterion } : { ...criterion, [_categoryKey]: categories }
            }
            if (!isEmpty(criterion)) _criteriaList.push(criterion)
        }
        return _criteriaList
    }
}

export default helpers
